import {UAM_WS_KEEP_ALIVE_INTERVAL, UAM_WS_KEEP_ALIVE_MESSAGE} from '../../consts/uam/uamWebSocketValues';
import DamWebSocketKeepAliveManager from '../dam/DamWebSocketKeepAliveManager';

export default class UamWebSocketKeepAliveManager extends DamWebSocketKeepAliveManager {
    constructor({client, assetId, onError}) {
        super({
            client,
            assetId,
            onError,
            logPrefix: 'uamWebSocketKeepAliveManager',
            keepAliveInterval: UAM_WS_KEEP_ALIVE_INTERVAL,
            keepAliveMessage: UAM_WS_KEEP_ALIVE_MESSAGE,
        });
    }
}
